import { render, staticRenderFns } from "./OpenPurchaseList.vue?vue&type=template&id=3fe32559&scoped=true&"
import script from "./OpenPurchaseList.vue?vue&type=script&lang=js&"
export * from "./OpenPurchaseList.vue?vue&type=script&lang=js&"
import style0 from "./OpenPurchaseList.vue?vue&type=style&index=0&id=3fe32559&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe32559",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCardText,VDataTable})
